import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../../assets/aw-footer-logo.jpg'


const _hoisted_1 = {
  "data-testid": "list-reports-page",
  class: "page list-reports-page"
}
const _hoisted_2 = {
  ref: "filterPanel",
  class: "mt-10 page-filters-wrapper mb-6"
}
const _hoisted_3 = ["threshold"]
const _hoisted_4 = {
  key: 0,
  height: "100%"
}
const _hoisted_5 = {
  key: 2,
  class: "report-template-pa"
}
const _hoisted_6 = { class: "card-data" }
const _hoisted_7 = { class: "page-content-pa" }
const _hoisted_8 = { class: "page-content-title-pa sub-header-title-pa" }
const _hoisted_9 = { class: "page-content-text-pa" }
const _hoisted_10 = { class: "page-content-title-pa text-center" }
const _hoisted_11 = { class: "page-content-text-pa" }
const _hoisted_12 = { class: "page-content-text-pa" }
const _hoisted_13 = { class: "page-content-title-pa text-center" }
const _hoisted_14 = { class: "page-content-text-pa" }
const _hoisted_15 = { class: "footer" }
const _hoisted_16 = { class: "report-template-pa" }
const _hoisted_17 = { class: "card-data" }
const _hoisted_18 = { class: "page-content-pa" }
const _hoisted_19 = { class: "report-chart-pa" }
const _hoisted_20 = { class: "footer" }
const _hoisted_21 = {
  key: 3,
  class: "report-template-pa"
}
const _hoisted_22 = { class: "card-data" }
const _hoisted_23 = { class: "page-content-pa" }
const _hoisted_24 = { class: "report-chart-pa" }
const _hoisted_25 = { class: "footer" }
const _hoisted_26 = {
  key: 4,
  class: "report-template-pa"
}
const _hoisted_27 = { class: "card-data" }
const _hoisted_28 = { class: "page-content-pa" }
const _hoisted_29 = { class: "report-chart-pa" }
const _hoisted_30 = { class: "footer" }
const _hoisted_31 = {
  key: 1,
  class: "d-flex align-center justify-center pt-5 mt-5"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_label = _resolveComponent("v-label")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_layout = _resolveComponent("v-layout")!
  const _component_ReportPageCover = _resolveComponent("ReportPageCover")!
  const _component_ScoreDist = _resolveComponent("ScoreDist")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_PriceTrackChart = _resolveComponent("PriceTrackChart")!
  const _component_IrrAndIav = _resolveComponent("IrrAndIav")!
  const _component_EPS = _resolveComponent("EPS")!
  const _component_SccAndIsy = _resolveComponent("SccAndIsy")!
  const _component_ReportStaticText = _resolveComponent("ReportStaticText")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          threshold: _ctx.filterPanelPosition,
          class: _normalizeClass(["navbar page-filters-panel pos-relative justify-space-between", _ctx.scrolledAll ? 'vue-fixed-header--isFixed' : ''])
        }, [
          _createVNode(_component_v_layout, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, {
                "no-gutters": "",
                align: "end",
                justify: "space-between"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    class: "d-flex",
                    cols: "12",
                    sm: "9"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "3",
                            "align-self": "center"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_label, null, {
                                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                                  _createTextVNode("Provider", -1)
                                ]))]),
                                _: 1
                              }),
                              _createVNode(_component_v_autocomplete, {
                                "model-value": _ctx.currentFilters.priceTrackId,
                                items: _ctx.priceTracks,
                                "item-title": "name",
                                "item-value": "id",
                                label: "Price Track",
                                variant: "solo",
                                disabled: _ctx.fetchingChartData,
                                "hide-details": "",
                                density: "compact",
                                class: "mt-2 filter-btn-active",
                                "single-line": "",
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = 
                        (e) => {
                          _ctx.onPriceTrackChange(e);
                        }
                      )
                              }, null, 8, ["model-value", "items", "disabled"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    class: "d-flex justify-end my-2",
                    cols: "12",
                    sm: "3"
                  }, {
                    default: _withCtx(() => [
                      false
                        ? (_openBlock(), _createBlock(_component_v_btn, {
                            key: 0,
                            class: "filter-btn back-btn elevation-6 mt-0 mr-2",
                            ripple: false,
                            variant: "text",
                            to: "/reports"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, { small: "" }, {
                                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                                  _createTextVNode("fas fa-arrow-left", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_v_btn, {
                        class: "filter-btn elevation-6 mt-0 mx-2",
                        ripple: false,
                        "data-testid": "ExportReportBtn",
                        variant: "text",
                        disabled: false,
                        loading: _ctx.processingReport,
                        onClick: _ctx.exportReport
                      }, {
                        default: _withCtx(() => [
                          _cache[6] || (_cache[6] = _createElementVNode("div", { class: "mx-2" }, "Export", -1)),
                          _createVNode(_component_v_icon, { small: "" }, {
                            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                              _createTextVNode("fas fa-file-pdf", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["loading", "onClick"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ], 10, _hoisted_3)
      ], 512),
      _createElementVNode("div", null, [
        (!_ctx.fetchingChartData)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (_ctx.currentFilters.coverPage)
                ? (_openBlock(), _createBlock(_component_ReportPageCover, {
                    key: 0,
                    data: _ctx.coverPageData,
                    chartData: _ctx.chartData
                  }, null, 8, ["data", "chartData"]))
                : _createCommentVNode("", true),
              (_ctx.currentFilters.awDist)
                ? (_openBlock(), _createBlock(_component_ScoreDist, {
                    key: 1,
                    data: _ctx.page2Data,
                    chartData: _ctx.chartData,
                    filters: _ctx.currentFilters
                  }, null, 8, ["data", "chartData", "filters"]))
                : _createCommentVNode("", true),
              (
              this.currentFilters.priceTrackObject &&
              this.currentFilters.priceTrackObject.details &&
              (this.currentFilters.priceTrackObject.details.beta ||
                this.currentFilters.priceTrackObject.details.beta == 0)
            )
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createVNode(_component_v_card, {
                      class: "report-page-card-pa",
                      outlined: "",
                      flat: ""
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.currentFilters.coverPage.title) + " Attribution Analysis ", 1),
                            _createElementVNode("div", _hoisted_9, [
                              _createTextVNode(" The following results are from the analysis conducted for a cohort of " + _toDisplayString(_ctx.numberWithCommas(_ctx.chartData.saversCount)) + " members over the time period of " + _toDisplayString(this.timePeriod) + ". ", 1),
                              _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1))
                            ]),
                            _cache[10] || (_cache[10] = _createElementVNode("div", { class: "page-content-title-pa" }, "Level of Risk Taken", -1)),
                            _cache[11] || (_cache[11] = _createElementVNode("div", { class: "page-content-text-pa" }, " The level of risk taken is represented by Beta (ß) which indicates the relative returns of the fund compared to the AgeWage benchmark index: ", -1)),
                            _createElementVNode("div", _hoisted_10, " Beta (ß) = " + _toDisplayString(this.currentFilters.priceTrackObject.details.beta), 1),
                            _createElementVNode("div", _hoisted_11, " The above Beta (ß) indicates that for a 1% benchmark return, the portfolio should have returned " + _toDisplayString(this.currentFilters.priceTrackObject.details.beta) + "% on a risk-adjusted basis. Hence if the portfolio returned more than " + _toDisplayString(this.currentFilters.priceTrackObject.details.beta) + " times the benchmark returns, it enhanced the outcome compared to the benchmark. As the Beta is " + _toDisplayString(+this.currentFilters.priceTrackObject.details.beta > 1 ? 'over' : 'under') + " 1, savers have been exposed to " + _toDisplayString(this.currentFilters.riskCompare) + " risk than benchmark and should be expecting a " + _toDisplayString(this.currentFilters.riskCompare) + " return " + _toDisplayString(this.currentFilters.priceTrackObject.details.returnCompare) + " the benchmark index over time. ", 1),
                            _cache[12] || (_cache[12] = _createElementVNode("div", { class: "page-content-title-pa" }, "Risk Adjusted Outcome", -1)),
                            _createElementVNode("div", _hoisted_12, " The risk-adjusted outcome represents the impact of factors such as costs, fees, stock selection, bid offer spread and other variables on the investment portfolio returns. The experienced portfolio index is compared to the benchmark index to understand the level of risk taken. It is subsequently used to calculate the outcome enhancement / shortfall based on the level of risk taken. Based on the data analysis conducted for " + _toDisplayString(_ctx.numberWithCommas(_ctx.chartData.saversCount)) + " members, the following portfolio outcome was determined (using the benchmark index as a comparison): ", 1),
                            _createElementVNode("div", _hoisted_13, " Risk Adjusted Annual Outcome " + _toDisplayString(this.currentFilters.priceTrackObject.details.alpha &&
                      this.currentFilters.priceTrackObject.details.alpha > 0
                        ? 'Enhancement'
                        : 'Shortfall') + " = " + _toDisplayString(this.currentFilters.priceTrackObject.details.alpha &&
                      Math.abs(this.currentFilters.priceTrackObject.details.alpha)) + "% ", 1),
                            _createElementVNode("div", _hoisted_14, [
                              _cache[8] || (_cache[8] = _createTextVNode(" The calculation indicates that ", -1)),
                              _cache[9] || (_cache[9] = _createElementVNode("b", null, " after adjusting for risks", -1)),
                              _createTextVNode(", the " + _toDisplayString(_ctx.currentFilters.coverPage.title) + " fund, on average, has generated " + _toDisplayString(this.currentFilters.priceTrackObject.details.alpha &&
                      Math.abs(this.currentFilters.priceTrackObject.details.alpha)) + "% " + _toDisplayString(this.currentFilters.priceTrackObject.details.benchmarkCompare) + " returns " + _toDisplayString(this.currentFilters.priceTrackObject.details.returnCompare) + " the benchmark index annually from " + _toDisplayString(this.timePeriod), 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_15, [
                          _cache[13] || (_cache[13] = _createElementVNode("div", null, null, -1)),
                          _createVNode(_component_v_img, {
                            class: "footer-img",
                            src: _imports_0
                          })
                        ])
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_component_v_card, {
                  class: "report-page-card-pa",
                  outlined: "",
                  flat: ""
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _cache[14] || (_cache[14] = _createElementVNode("div", { class: "page-content-title-pa" }, "Price Track Comparison", -1)),
                        _cache[15] || (_cache[15] = _createElementVNode("div", { class: "page-content-text-pa" }, " This figure shows how the portfolio price index has changed over time compared to the benchmark index. The difference between the indexes highlights the effects of asset allocation, fees and charges, stock selection, sequential risk and other variables on the portfolio's performance. ", -1)),
                        _createElementVNode("div", _hoisted_19, [
                          _createVNode(_component_PriceTrackChart, {
                            chartData: _ctx.getPriceTrackGraph(),
                            title: "Price Track Comparison"
                          }, null, 8, ["chartData"])
                        ]),
                        _cache[16] || (_cache[16] = _createElementVNode("div", { class: "chart-legend-pa" }, "Figure : Portfolio vs Benchmark price track", -1))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _cache[17] || (_cache[17] = _createElementVNode("div", null, null, -1)),
                      _createVNode(_component_v_img, {
                        class: "footer-img",
                        src: _imports_0
                      })
                    ])
                  ]),
                  _: 1
                })
              ]),
              (_ctx.pastPerformanceFetched)
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                    _createVNode(_component_v_card, {
                      class: "report-page-card-pa",
                      outlined: "",
                      flat: ""
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("div", _hoisted_23, [
                            _cache[18] || (_cache[18] = _createElementVNode("div", { class: "page-content-title-pa" }, "Past Performance Comparison", -1)),
                            _cache[19] || (_cache[19] = _createElementVNode("div", { class: "page-content-text-pa" }, " This figure shows how the AgeWage scores have changed over time. ", -1)),
                            _createElementVNode("div", _hoisted_24, [
                              _createVNode(_component_PriceTrackChart, {
                                chartData: _ctx.getPastPerformanceGraph(),
                                title: "Past Performance Comparison"
                              }, null, 8, ["chartData"])
                            ]),
                            _cache[20] || (_cache[20] = _createElementVNode("div", { class: "chart-legend-pa" }, "Figure : AgeWage Score vs Time", -1))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_25, [
                          _cache[21] || (_cache[21] = _createElementVNode("div", null, null, -1)),
                          _createVNode(_component_v_img, {
                            class: "footer-img",
                            src: _imports_0
                          })
                        ])
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              (
              this.currentFilters.priceTrackObject &&
              this.currentFilters.priceTrackObject.details &&
              (this.currentFilters.priceTrackObject.details.beta ||
                this.currentFilters.priceTrackObject.details.beta == 0)
            )
                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                    _createVNode(_component_v_card, {
                      class: "report-page-card-pa",
                      outlined: "",
                      flat: ""
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_27, [
                          _createElementVNode("div", _hoisted_28, [
                            _cache[22] || (_cache[22] = _createElementVNode("div", { class: "page-content-title-pa" }, "Monthly deltas over time", -1)),
                            _cache[23] || (_cache[23] = _createElementVNode("div", { class: "page-content-text-pa" }, "This figure shows delta over the last month's return.", -1)),
                            _createElementVNode("div", _hoisted_29, [
                              _createVNode(_component_PriceTrackChart, {
                                chartData: _ctx.getDeltaGraph(),
                                title: "Delta over time"
                              }, null, 8, ["chartData"])
                            ]),
                            _cache[24] || (_cache[24] = _createElementVNode("div", { class: "chart-legend-pa" }, "Figure : Delta vs Time", -1))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_30, [
                          _cache[25] || (_cache[25] = _createElementVNode("div", null, null, -1)),
                          _createVNode(_component_v_img, {
                            class: "footer-img",
                            src: _imports_0
                          })
                        ])
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              (_ctx.currentFilters.iAsset || _ctx.currentFilters.Irr)
                ? (_openBlock(), _createBlock(_component_IrrAndIav, {
                    key: 5,
                    data: _ctx.page2Data,
                    chartData: _ctx.irrAndIavData,
                    filters: _ctx.currentFilters
                  }, null, 8, ["data", "chartData", "filters"]))
                : _createCommentVNode("", true),
              (_ctx.currentFilters.ePotSize)
                ? (_openBlock(), _createBlock(_component_EPS, {
                    key: 6,
                    data: _ctx.page2Data,
                    chartData: _ctx.ePotData,
                    filters: _ctx.currentFilters
                  }, null, 8, ["data", "chartData", "filters"]))
                : _createCommentVNode("", true),
              ((_ctx.sccAndIsyData && _ctx.currentFilters.schemeSeg) || _ctx.currentFilters.yearSeg)
                ? (_openBlock(), _createBlock(_component_SccAndIsy, {
                    key: 7,
                    data: _ctx.page2Data,
                    chartData: _ctx.sccAndIsyData,
                    filters: _ctx.currentFilters
                  }, null, 8, ["data", "chartData", "filters"]))
                : _createCommentVNode("", true),
              _createVNode(_component_ReportStaticText)
            ]))
          : _createCommentVNode("", true),
        (_ctx.fetchingChartData)
          ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
              _createVNode(_component_v_progress_circular, {
                indeterminate: "",
                color: "grey"
              })
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_v_snackbar, {
      modelValue: _ctx.pdfTimeoutError,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.pdfTimeoutError) = $event)),
      timeout: 3000,
      color: "primary",
      location: "top"
    }, {
      default: _withCtx(() => [
        _cache[27] || (_cache[27] = _createElementVNode("h3", null, "Error downloading requested pdf. Please try again.", -1)),
        _createVNode(_component_v_btn, {
          color: "blue",
          variant: "text",
          class: "d-flex ml-auto",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.pdfTimeoutError = false))
        }, {
          default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
            _createTextVNode(" Close ", -1)
          ]))]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}